import { render, staticRenderFns } from "./IntroductionSNS.vue?vue&type=template&id=4b335bb2&"
import script from "./IntroductionSNS.vue?vue&type=script&lang=js&"
export * from "./IntroductionSNS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports